import { Component, OnInit } from '@angular/core';

import { ExampleArticleItem } from '../import/upload/example-article-item';
import { DataService } from '../shared/network/data.service';

@Component({
    selector: 'articles-view',
    templateUrl: './articles-view.component.html',
    styleUrls: ['./articles-view.component.scss']
})
export class ArticlesViewComponent implements OnInit {
    exampleArticles: ExampleArticleItem[] = undefined;
    public articlesFilterStr = '';
    private articlesDisplayCount = 4;

    dataLoaded = false;
    public loading = false;

    constructor(private dataService: DataService) { }

    ngOnInit(): void {
        let self = this;
        this.dataService.get<ExampleArticleItem[]>('articles/examples').then(items => {
            self.exampleArticles = items;
        });
    }

    public showMoreArticlesClick() {
        this.articlesDisplayCount += 4;
    }

    get filteredArticles(): ExampleArticleItem[] {
        return this.exampleArticles.filter(article => article.title.toUpperCase().includes(this.articlesFilterStr.toUpperCase()))
            .slice(0, this.articlesDisplayCount);
    }
    
}
